export default "__VITE_ASSET__CWo$1mvb__"